// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-15842499-7',
  router,
  set: [
    { field: 'anonymize_ip', value: true }
  ]
})
Vue.use(VueScrollTo)
Vue.use(BootstrapVue)

require('./assets/css/main.css')

Vue.config.productionTip = false
let app
let config = {
  apiKey: 'AIzaSyD5kHzodiXgDHdqiWAOY1ZWYlGUqYLRQpU',
  authDomain: 'maxkade-c1af4.firebaseapp.com',
  databaseURL: 'https://maxkade-c1af4.firebaseio.com',
  projectId: 'maxkade-c1af4',
  storageBucket: 'maxkade-c1af4.appspot.com',
  messagingSenderId: '557990018171',
  timestampsInSnapshots: true
}
firebase.initializeApp(config)

const settings = {timestampsInSnapshots: true}
export const db = firebase.firestore()
db.settings(settings)
firebase.auth().useDeviceLanguage()
firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js